module.exports = __webpack_public_path__ + "img/yixiang.c93a4784.png";